const leaflets = {
    "apulia": {
        "config": {
            "primary-color": "#01538A",
            "secondary-color": "#E1001B",
            "tertiary-color": "#ffdd00",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "clientIcon": require("assets/images/icona-Carrefour.png"),
            "serverPath": "carrefour-apulia.volantinointerattivo.net/",
            "pdfPath": "/media/pdf/volantino.pdf",
            "shareFlyerTitle": "Dai uno sguardo al nuovo catalogo estivo Carrefour!",
            "shareFlyerURL": "https://carrefour-apulia.volantinointerattivo.net",
            "shareProductSentence": "Guarda questa fantastica offerta!",
            "ogTitleMeta": "Volantino Interattivo",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo catalogo estivo.",
            "ogImageMeta": "https://carrefour-apulia.volantinointerattivo.net/media/images/apulia_fb_01.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": true,
            "ga_tracking_id": "UA-152069090-23",
            "release_id": "1",
            "send_grocery_list_to_market": true,
            "grocery_list_min_value": 0.10,
            "client_id": 11,
            "signboard_id": 33,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": false,
            "category_banner": ""
        },
        "leaflet": {
            "name": "Catalogo Estate Carrefour - Apulia",
            "code": "456",
            "id_campaign": "456",
            "index": {
                "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/Indice_Carrefour_Tavola_disegno_1_lMDl7ln.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 27.725940951093083,
                            "left": 12.745849297573438,
                            "width": 74.23690932311622,
                            "height": 3.8073773570730967
                        }
                    },
                    {
                        "page": 4,
                        "blueprint": {
                            "top": 35.58034708136128,
                            "left": 12.745849297573438,
                            "width": 74.23690932311622,
                            "height": 3.8073773570730967
                        }
                    },
                    {
                        "page": 8,
                        "blueprint": {
                            "top": 43.626324092855526,
                            "left": 13.198169433801619,
                            "width": 74.23690932311622,
                            "height": 3.8073773570730967
                        }
                    },
                    {
                        "page": 9,
                        "blueprint": {
                            "top": 51.863871985575834,
                            "left": 13.017241379310345,
                            "width": 74.23690932311622,
                            "height": 3.8073773570730967
                        }
                    },
                    {
                        "page": 16,
                        "blueprint": {
                            "top": 60.10141987829615,
                            "left": 13.107705406555985,
                            "width": 74.23690932311622,
                            "height": 3.8073773570730967
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Giochi e Giocattoli",
                    "subcategories": [
                        "Giochi all'Aperto",
                        "Altro"
                    ]
                },
                {
                    "category_name": "Sport e Tempo Libero",
                    "subcategories": [
                        "Camping e Outdoor",
                        "Nuoto",
                        "Altro"
                    ]
                },
                {
                    "category_name": "Giardino e Giardinaggio",
                    "subcategories": [
                        "Barbecue e picnic",
                        "Arredamento",
                        "Accessori",
                        "Altro"
                    ]
                },
                {
                    "category_name": "Casa e Cucina",
                    "subcategories": [
                        "Altro"
                    ]
                },
                {
                    "category_name": "Abbigliamento",
                    "subcategories": [
                        "Accessori"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_1_sOuSPOz.jpg",
                    "products": [
                        {
                            "item_id": "213304",
                            "field1": "BEST WAY",
                            "field2": "Cavalcabile luxury fenicottero cm 173x170/",
                            "field3": "luxury pegaso cm 231x150/",
                            "field4": "pop art barcellona lama cm 193x151",
                            "description": "BEST WAY Cavalcabile luxury fenicottero cm 173x170/ luxury pegaso cm 231x150/ pop art barcellona lama cm 193x151",
                            "grammage": null,
                            "price": "24.99",
                            "price_label": "€ 24,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fenicottero",
                                "Pegaso",
                                "Pop art Barcellona lama"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 37.811900191938584,
                                "left": 5.15722968650032,
                                "width": 89.7760183407976,
                                "height": 32.693538067818295
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138966862_1590160666.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138952407_1590160666.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138952285_1590160666.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_znyDtTd_1nwqQ6Q.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213296",
                            "field1": "COVERI BORDING",
                            "field2": "Zaino frigo in poliestere ",
                            "field3": "4 colori",
                            "field4": "lt 21",
                            "description": "COVERI BORDING Zaino frigo in poliestere  4 colori lt 21",
                            "grammage": null,
                            "price": "9.99",
                            "price_label": "€ 9,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 66.41074856046065,
                                "left": 32.30054382597567,
                                "width": 62.270793346129246,
                                "height": 29.878438899552144
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8032089270380_1590160655.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_4Etl7eD_BWAwYhz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213288",
                            "field1": "STUOIA MARE FIJI",
                            "field2": "4 colori ",
                            "field3": "cm 180x60",
                            "field4": "",
                            "description": "STUOIA MARE FIJI 4 colori  cm 180x60",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 69.48176583493282,
                                "left": 5.428662827895073,
                                "width": 33.2053209639582,
                                "height": 26.807421625079975
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8006881198067_1590160647.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_sofZj2L_9s5otCc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Lavare i teli da mare e rimuovere la salsedine",
                                    "data": {
                                        "titolo": "Lavare i teli da mare e rimuovere la salsedine",
                                        "testo": "Ecco tutto quello che dovrai fare, tornata dalla vacanza, per far fuori sabbia e aloni di unto:\n\n- Scrolla bene la stuoia per eliminare la sabbia, puoi aiutarti con una spazzola dalle setole morbide.\n- Spruzza lo sgrassatore su una spugnetta e passala sulla stuoia. Se ci sono aloni, lascia agire il prodotto per qualche minuto.\n- Con un panno umido rimuovi lo sgrassatore.\n- Passa un panno asciutto sulla stuoia e falla asciugare all’aria aperta.\n\nE adesso… goditi il mare e le tue giornate rilassanti in spiaggia!\n(Fonte: detersiviscala.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/images/telo-mare-spiaggia.jpg"
                                        ]
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_2_0JiiM1l.jpg",
                    "products": [
                        {
                            "item_id": "86846",
                            "field1": "VALIGETTA PIC NIC",
                            "field2": "Pieghevole",
                            "field3": "+ griglia",
                            "field4": "cm 43x21h55 ",
                            "description": "VALIGETTA PIC NIC Pieghevole + griglia cm 43x21h55 ",
                            "grammage": null,
                            "price": "22.99",
                            "price_label": "€ 22,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 7.165706973768394,
                                "left": 0.0,
                                "width": 49.762742589038176,
                                "height": 23.6724248240563
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1055048_1490020848.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8028353113231_1590160626.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_cs0hkfV_MCppRAt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213273",
                            "field1": "BARBECUE SENZA RUOTE",
                            "field2": "+ griglia",
                            "field3": "cm 30x45",
                            "field4": "",
                            "description": "BARBECUE SENZA RUOTE + griglia cm 30x45",
                            "grammage": null,
                            "price": "29.99",
                            "price_label": "€ 29,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 7.293666026871401,
                                "left": 50.23725741096183,
                                "width": 49.762742589038176,
                                "height": 23.6724248240563
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8025921003451_1590160627.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_2Hr7Xcb_0bk6tJx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Come pulire il barbecue",
                                    "data": {
                                        "titolo": "Come pulire il barbecue - Il detergente magico e fatto in casa",
                                        "testo": "Ingredienti: un biccchiere di alcool etilico rosa (non l’acool bianco da pulizie, che è tossico), un cucchiaio da cucina di percarbonato di sodio puro o, in alternativa, di sbiancante per bucato, mezzo cucchiaio di detersivo liquido per piatti, acqua, q.b. per riempire un flacone riciclato, con spruzzatore, un flacone con spruzzatore e una piccola caraffa.\nDato che il percarbonato di sodio è poco solubile in acqua, si deve procedere sciogliendolo in acqua in una caraffa e aspettando di far depositare quello insoluto. A questo punto, si preleva solo il liquido ottenuto, senza il deposito. Si versa prima il bicchiere di alcool nel flacone, poi il detersivo per piatti ed infine la soluzione di acqua e percarbonato. Si termina, naturalmente, agitando il tutto. Questo sgrassatore alcalino si può benissimo spruzzare direttamente sulle griglie ancora calde, in questo modo, il grasso non si sarà solidificato e si eliminerà senza fatica. Non avendo ingredienti tossici, come quelli commerciali, anche l’eventuale riscaldamento, infatti, non comporterà la produzione di fumi nocivi.\n(Fonte: bbq4all.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/images/detergente-fatto-in-casa-1024x682.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "213267",
                            "field1": "BISTECCHIERA TEFLON",
                            "field2": "Con fondo e manico in legno pieghevole ",
                            "field3": "cm 27x30",
                            "field4": "",
                            "description": "BISTECCHIERA TEFLON Con fondo e manico in legno pieghevole  cm 27x30",
                            "grammage": null,
                            "price": "13.99",
                            "price_label": "€ 13,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 33.07741522712732,
                                "left": 0.0,
                                "width": 47.8627105992749,
                                "height": 35.060780550223924
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8010387030295_1590160621.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_IU2mbao_UPm8F1v.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213274",
                            "field1": "MAX",
                            "field2": "Barbecue grill",
                            "field3": "2000W ",
                            "field4": "Griglia cm47x22",
                            "description": "MAX Barbecue grill 2000W  Griglia cm47x22",
                            "grammage": null,
                            "price": "49.99",
                            "price_label": "€ 49,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 33.07741522712732,
                                "left": 38.99589464704628,
                                "width": 60.43911281723182,
                                "height": 35.060780550223924
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8017365040611_1590160627.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_8lpf90x_w87sIIF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213271",
                            "field1": "MACA",
                            "field2": "Graticola 13 barre liscia ",
                            "field3": "cm 25x30",
                            "field4": "",
                            "description": "MACA Graticola 13 barre liscia  cm 25x30",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 69.41778630838132,
                                "left": 0.09047771379825122,
                                "width": 49.762742589038176,
                                "height": 25.207933461292384
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8058159310183_1590160623.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_Ce9tCIy_G1V3o9P.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "86847",
                            "field1": "FORNACELLA RETTANGOLARE GRANDE",
                            "field2": "Pieghevole",
                            "field3": "+ griglia",
                            "field4": "cm 27x37",
                            "description": "FORNACELLA RETTANGOLARE GRANDE Pieghevole + griglia cm 27x37",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 69.22584772872682,
                                "left": 50.23725741096183,
                                "width": 49.762742589038176,
                                "height": 25.207933461292384
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8025921002003_1590160625.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_hSoGOEu_hjBAd7M.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_3_uMSG5iT.jpg",
                    "products": [
                        {
                            "item_id": "213269",
                            "field1": "PENNELLO/FORCHETTONE",
                            "field2": "Per barbecue in acciaio blister",
                            "field3": "",
                            "field4": "",
                            "description": "PENNELLO/FORCHETTONE Per barbecue in acciaio blister",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 7.357645553422905,
                                "left": 0.0,
                                "width": 49.77380571550437,
                                "height": 24.056301983365323
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8025569795657_1590160622_1591703279.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8025569795688_1590160622_1591703279.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_rGVj8cv_8b82ZZC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213268",
                            "field1": "DE LUCA",
                            "field2": "Pinza chef inox 18/110 ",
                            "field3": "cm 30",
                            "field4": "",
                            "description": "DE LUCA Pinza chef inox 18/110  cm 30",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 7.1017274472168905,
                                "left": 50.04523885689912,
                                "width": 49.95476114310088,
                                "height": 25.015994881637877
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8026996306676_1590160621.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_daYlMkQ_bx9F1lC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213272",
                            "field1": "PINZA/SPATOLA/SPAZZOLA",
                            "field2": "Per barbecue in acciaio blister",
                            "field3": "",
                            "field4": "",
                            "description": "PINZA/SPATOLA/SPAZZOLA Per barbecue in acciaio blister",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 32.94945617402431,
                                "left": 0.0,
                                "width": 100.0,
                                "height": 35.444657709532954
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8025569795695_1590160624.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8025569795640_1590160624.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8025569795664_1590160624.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_2Q67se3_tkJiQZO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "113996",
                            "field1": "LA FORNACELLA",
                            "field2": "Carbone vegetale",
                            "field3": "kg 2,5",
                            "field4": "",
                            "description": "LA FORNACELLA Carbone vegetale kg 2,5",
                            "grammage": 2500,
                            "price": "2.19",
                            "price_label": "€ 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 69.09788867562379,
                                "left": 0.0,
                                "width": 49.78486884197057,
                                "height": 25.463851567498402
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/52538_1520940328.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_r4olOL0_MXQW5hb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213314",
                            "field1": "DIAVOLINA",
                            "field2": "Accendifuoco ",
                            "field3": "40 cubi",
                            "field4": "",
                            "description": "DIAVOLINA Accendifuoco  40 cubi",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 69.22584772872682,
                                "left": 50.21513115802943,
                                "width": 49.78486884197057,
                                "height": 25.463851567498402
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/2875_1591705564.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_cX29rys_xZBvODJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/video/Spot_Diavolina.mp4"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_4_0dHKOn3.jpg",
                    "products": [
                        {
                            "item_id": "213280",
                            "field1": "SEDIA LIDO",
                            "field2": "Con braccioli in plastica bianca ",
                            "field3": "cm 56x58x90h",
                            "field4": "",
                            "description": "SEDIA LIDO Con braccioli in plastica bianca  cm 56x58x90h",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 7.037747920665387,
                                "left": 0.0,
                                "width": 49.77380571550437,
                                "height": 25.015994881637877
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651003007_1590160636.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_P5wUGyl_aNaditq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "212284",
                            "field1": "TAVOLO PLASTICA MARTE",
                            "field2": "Bianco/verde",
                            "field3": "cm 100x67x72h",
                            "field4": "",
                            "description": "TAVOLO PLASTICA MARTE Bianco/verde cm 100x67x72h",
                            "grammage": null,
                            "price": "19.99",
                            "price_label": "€ 19,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Verde"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 50.22619428449563,
                                "width": 49.77380571550437,
                                "height": 25.015994881637877
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1034394_1589192691.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651133216_1590160638.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651133001_1590160638.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_nRpz75h_YRVnLsi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213281",
                            "field1": "ARETA",
                            "field2": "Tavolo nettuno quadrato in plastica ",
                            "field3": "bianco/verde ",
                            "field4": "cm 80x80x72h",
                            "description": "ARETA Tavolo nettuno quadrato in plastica  bianco/verde  cm 80x80x72h",
                            "grammage": null,
                            "price": "18.99",
                            "price_label": "€ 18,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Verde"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 33.01343570057581,
                                "left": 41.63081147366176,
                                "width": 58.369188526338235,
                                "height": 35.252719129878436
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651116219_1590160639.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651116004_1590160639.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_Xmhg2Tj_7foXmx2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "212282",
                            "field1": "SEDIA PLASTICA ISCHIA",
                            "field2": "Con braccioli",
                            "field3": "bianca/verde",
                            "field4": "cm 55x54x85h",
                            "description": "SEDIA PLASTICA ISCHIA Con braccioli bianca/verde cm 55x54x85h",
                            "grammage": null,
                            "price": "7.99",
                            "price_label": "€ 7,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianca",
                                "Verde"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 33.07741522712732,
                                "left": 0.0,
                                "width": 58.369188526338235,
                                "height": 35.252719129878436
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1034396_1589192328.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1068735_1589192568.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651026211_1590160636.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651026006_1590160636.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_y9NcQ49_HuWcjza.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89571",
                            "field1": "SELENE",
                            "field2": "Sedia plastica rattan",
                            "field3": "caffè/bianca",
                            "field4": "cm 55x46x85h",
                            "description": "SELENE Sedia plastica rattan caffè/bianca cm 55x46x85h",
                            "grammage": null,
                            "price": "29.99",
                            "price_label": "€ 29,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Caffè",
                                "Bianca"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 69.16186820217533,
                                "left": 0.0,
                                "width": 50.316671998293884,
                                "height": 25.335892514395393
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1036347_1492704759.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1033810_1492704770.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651022411_1590160637.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651022008_1590160637.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_EpA2i1D_N7QGL8h.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "214439",
                            "field1": "SATURNO ",
                            "field2": "Tavolo plastica rattan ",
                            "field3": "caffè/bianco ",
                            "field4": "cm 80x80x72h",
                            "description": "SATURNO  Tavolo plastica rattan  caffè/bianco  cm 80x80x72h",
                            "grammage": null,
                            "price": "39.99",
                            "price_label": "€ 39,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Caffè",
                                "Bianco"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 69.09788867562379,
                                "left": 44.8880091703988,
                                "width": 55.11199082960119,
                                "height": 25.335892514395393
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/tavolo_rattan_bianco_1591706103.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/tavolo_marrone_rattan_1591706103.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_zjDqq3B_y7I5F5P.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_5_vU6k6Rf.jpg",
                    "products": [
                        {
                            "item_id": "213278",
                            "field1": "DIANA",
                            "field2": "Poltrona bianca 5 posizioni ",
                            "field3": "",
                            "field4": "",
                            "description": "DIANA Poltrona bianca 5 posizioni ",
                            "grammage": null,
                            "price": "29.99",
                            "price_label": "€ 29,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 7.165706973768394,
                                "left": 0.0,
                                "width": 49.77380571550437,
                                "height": 25.143953934740882
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651052005_1590160633.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_01o36hR_g8DIlNZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "212939",
                            "field1": "SEDIA BABY ADRIA",
                            "field2": "in Plastica",
                            "field3": "colori assortiti",
                            "field4": "",
                            "description": "SEDIA BABY ADRIA in Plastica colori assortiti",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 7.293666026871401,
                                "left": 50.22619428449563,
                                "width": 49.77380571550437,
                                "height": 25.143953934740882
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8003723201923_1590160635_1591703732.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_mpn1rZ3_tpjKx3a.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89574",
                            "field1": "PANCHINA ATENA BIANCA",
                            "field2": "in Plastica",
                            "field3": "cm 150x51h73",
                            "field4": "",
                            "description": "PANCHINA ATENA BIANCA in Plastica cm 150x51h73",
                            "grammage": null,
                            "price": "39.99",
                            "price_label": "€ 39,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 33.01343570057581,
                                "left": 0.0,
                                "width": 64.1597622094263,
                                "height": 35.252719129878436
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1034529_1492704994.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008651538004_1590160632.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_rMF1bB4_NNi3mzA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213277",
                            "field1": "TORCIA A OLIO BAMBOO",
                            "field2": "Con contenitore + stoppino",
                            "field3": "cm 120/150",
                            "field4": "",
                            "description": "TORCIA A OLIO BAMBOO Con contenitore + stoppino cm 120/150",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "120 cm",
                                "150 cm"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 33.01343570057581,
                                "left": 64.1597622094263,
                                "width": 35.84023779057369,
                                "height": 35.252719129878436
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8004944206247_1590160631.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8004944206230_1590160631.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_4geLg2l_vFdO0ss.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Come illuminare il giardino",
                                    "data": {
                                        "titolo": "Come illuminare il giardino",
                                        "testo": "Una cattiva illuminazione del giardino, infatti, rischia di vanificare tutti i nostri sforzi. Le idee che vi proponiamo di seguito, unite ad un consulto con un professionista del settore, permetteranno a chiunque di realizzare un sistema di illuminazione su misura del proprio giardino; il tutto senza spendere cifre importanti in questo progetto e ovviamente – caratteristica più importante – ottenendo un risultato spettacolare. Nello specifico ci occuperemo dell’illuminazione del giardino con le torce.\nInnanzitutto ricordiamo che generalmente le torce da esterni funzionano ad olio, pertanto, trattandosi di articoli collocati nelle vicinanze di piante e alberi, è consigliabile utilizzare un olio naturale, che non emetta sostanze nocive.\nSe vogliamo rendere la fiamma delle torce davvero spettacolare, possiamo utilizzare prodotti alternativi, ad esempio l’olio di paraffina o l’olio di paraffina alla citronella (questa sostanza è molto apprezzata nella stagione estiva perché ci aiuta a tenere lontani gli insetti). Possiamo riservare i due prodotti sopra citati alle occasioni particolari (ad esempio una riunione tra amici), durante le quali possiamo sorprendere i nostri invitati con un’illuminazione meravigliosa.\nPrima di accendere la torcia ed appena dopo averla riempita di olio, dobbiamo aspettare circa cinque minuti; è il tempo necessario affinché lo stoppino entri a contatto diretto con la sostanza, aspetto fondamentale per ottenere un’illuminazione ottimale.\nPer quanto riguarda lo stile delle torce, possiamo affidarci al nostro gusto personale ma è sempre consigliabile rivolgersi ad un professionista, il quale saprà consigliarci la torcia più adatta per il nostro giardino.\n(Fonte blog.habitissimo.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/images/antorchas-para-el-jard%C3%ADn.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "89599",
                            "field1": "ARELLA CINA ",
                            "field2": "Confezionata ",
                            "field3": "varie misure",
                            "field4": "",
                            "description": "ARELLA CINA  Confezionata  varie misure",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 69.09788867562379,
                                "left": 0.0,
                                "width": 49.78486884197057,
                                "height": 25.463851567498402
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1036359_1492708483.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8004944006113_1590160630.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8004944061129_1590160631.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8004944061136_1590160631.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_t1v66GN_PcLhdkT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213311",
                            "field1": "VENTILATORE DA TAVOLO",
                            "field2": "Blu 40 watt ",
                            "field3": "cm 30",
                            "field4": "",
                            "description": "VENTILATORE DA TAVOLO Blu 40 watt  cm 30",
                            "grammage": null,
                            "price": "21.99",
                            "price_label": "€ 21,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 69.16186820217533,
                                "left": 50.21513115802943,
                                "width": 49.78486884197057,
                                "height": 25.463851567498402
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8029121931965_1590160678.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_Qqjxfm6_oquKtTO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 6,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_6_SpEn0tY.jpg",
                    "products": [
                        {
                            "item_id": "93669",
                            "field1": "SEDIA RELAX BASSA ",
                            "field2": "Primula bianca",
                            "field3": "colori assortiti",
                            "field4": "",
                            "description": "SEDIA RELAX BASSA  Primula bianca colori assortiti",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 7.1017274472168905,
                                "left": 0.0,
                                "width": 49.95476114310088,
                                "height": 25.07997440818938
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1034524_1496234049.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8003723032206_1590160656.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_oA3CiEn_ELv4X9r.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213298",
                            "field1": "SDRAIO CANAPONE SOLIX OXFORD",
                            "field2": "Rossa ",
                            "field3": "coveri bording ",
                            "field4": "",
                            "description": "SDRAIO CANAPONE SOLIX OXFORD Rossa  coveri bording ",
                            "grammage": null,
                            "price": "25.99",
                            "price_label": "€ 25,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 50.04523885689912,
                                "width": 49.95476114310088,
                                "height": 25.07997440818938
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8056378094105_1590160657.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_Ojy6ugM_63zcWx2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213297",
                            "field1": "SDRAIO BOSTON",
                            "field2": "Reclinabile ",
                            "field3": "fantasie varie",
                            "field4": "",
                            "description": "SDRAIO BOSTON Reclinabile  fantasie varie",
                            "grammage": null,
                            "price": "35.99",
                            "price_label": "€ 35,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 32.94945617402431,
                                "left": 0.0,
                                "width": 100.0,
                                "height": 35.380678182981434
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8003723068250_1590160656.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_io3fEa7_bpMeAjG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213279",
                            "field1": "POLTRONA RELAX VIRTUS",
                            "field2": "Con cuscino in ferro ",
                            "field3": "natural/grey",
                            "field4": "mm 22 - cm 165x65h113",
                            "description": "POLTRONA RELAX VIRTUS Con cuscino in ferro  natural/grey mm 22 - cm 165x65h113",
                            "grammage": null,
                            "price": "39.99",
                            "price_label": "€ 39,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Natural",
                                "Grey"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 69.22584772872682,
                                "left": 0.0,
                                "width": 49.69439112817232,
                                "height": 25.207933461292384
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8056457143984_1590160633.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8056457142086_1590160633.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_EhBtKfT_XLV5Ut2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "89578",
                            "field1": "SDRAIO POMPEI LUX",
                            "field2": "Reclinabile",
                            "field3": "fantasie varie",
                            "field4": "",
                            "description": "SDRAIO POMPEI LUX Reclinabile fantasie varie",
                            "grammage": null,
                            "price": "49.99",
                            "price_label": "€ 49,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 69.22584772872682,
                                "left": 50.30560887182768,
                                "width": 49.69439112817232,
                                "height": 25.207933461292384
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1055658_1492705254.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8003723069011_1590160658.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_BqZZXTh_IW2Dkir.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 7,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_7_lRVofGt.jpg",
                    "products": [
                        {
                            "item_id": "213315",
                            "field1": "CARREFOUR",
                            "field2": "Spirali",
                            "field3": "pz 10",
                            "field4": "",
                            "description": "CARREFOUR Spirali pz 10",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 7.293666026871401,
                                "left": 0.0,
                                "width": 49.864283429302624,
                                "height": 24.56813819577735
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/spirali_zanzare_1591705633.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_uaZlnRp_4aBpeu7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213319",
                            "field1": "ZANZIR",
                            "field2": "Citronella di java padella",
                            "field3": "diametro cm 10 pz 3",
                            "field4": "",
                            "description": "ZANZIR Citronella di java padella diametro cm 10 pz 3",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 50.135716570697376,
                                "width": 49.864283429302624,
                                "height": 24.824056301983365
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/52629_1591705918.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_LyMQSjV_75HngqB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Perché la citronella allontana le zanzare",
                                    "data": {
                                        "titolo": "Perché la citronella allontana le zanzare",
                                        "testo": "La citronella è una pianta erbacea perenne originaria dell’Asia, che fa parte della famiglia delle graminacee. La sua particolarità è l’odore delle sue foglie che ricorda un po’ quello del limone: in Oriente vien spesso usata in cucina come sostituto di questo agrume.\nIl suo olio essenziale, che si ottiene per distillazione in corrente di vapore delle foglie, ha un odore che è naturalmente sgradito agli insetti. Fa parte infatti di quelle piante – insieme a lavanda, neem e molte altre – che hanno un’azione repellente per gli insetti: il profumo delle piante è spesso un’arma difensiva contro gli insetti che rischierebbero di creare danno alla pianta.\nUn prodotto che contenga olio essenziale di citronella puro al 100% permette di tenere lontane le zanzare e altri insetti sgradevoli che d’estate popolano il giardino o i luoghi all’aria aperta. E, poiché si tratta di un prodotto naturale, può essere indicato anche per proteggere la delicata pelle dei bambini.\nL’odore può risultare un po’ intenso, ma il beneficio è davvero notevole.\n(Fonte: macrolibrarsi.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/images/citronella.la.pianta.dell.estate.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "213313",
                            "field1": "TERRICCIO UNIVERSALE",
                            "field2": "Eco",
                            "field3": "lt 20",
                            "field4": "",
                            "description": "TERRICCIO UNIVERSALE Eco lt 20",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 32.94945617402431,
                                "left": 0.0,
                                "width": 58.28977393900619,
                                "height": 35.316698656429935
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/terriccio_universale_1591705489.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_BVoQgs5_o5oyFC5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Terriccio universale",
                                    "data": {
                                        "titolo": "Terriccio universale",
                                        "testo": "Il terriccio universale è una miscela di elementi diversi. Ogni produttore impiega la sua personale composizione, tuttavia, generalmente, la miscela del terriccio universale comprende elementi come: humus, terriccio di brughiera, sabbia, torba, argilla espansa sminuzzata.\nQuesti substrati vengono miscelati tra loro così da costituire un terriccio fertile e permeabile, adatto a fornire i giusti nutrienti alle piante. Il terriccio universale può essere usato al momento del rinvaso delle piante da appartamento a aggiunto al terreno del giardino o dell’orto al momento della messa a dimora di alberi o arbusti in terreni non particolarmente ricchi. Se il terreno non è fertile, il terriccio universale può essere aggiunto contestualmente a compost e letame ben maturo duranti i lavori di preparazione del terreno, sfruttando la tecnica della vangatura profonda.\n(Fonte ideegreen.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/images/terriccio_universale_1591705489.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "213318",
                            "field1": "ZANZIR",
                            "field2": "Citronella di java coccio",
                            "field3": "diametro cm 17",
                            "field4": "",
                            "description": "ZANZIR Citronella di java coccio diametro cm 17",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 32.94945617402431,
                                "left": 58.28977393900617,
                                "width": 41.71022606099382,
                                "height": 35.316698656429935
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/citronella_coccio_1591705886.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_d2fIHMP_IGkzYOZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213316",
                            "field1": "CARREFOUR",
                            "field2": "Elettroemanatore + ricarica",
                            "field3": "ml 33",
                            "field4": "",
                            "description": "CARREFOUR Elettroemanatore + ricarica ml 33",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 69.16186820217533,
                                "left": 0.0,
                                "width": 34.56248667093197,
                                "height": 25.27191298784389
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/4001334_1591705730.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_oyxgnpj_VMrF9xo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213317",
                            "field1": "CARREFOUR",
                            "field2": "Ricarica",
                            "field3": "ml 33",
                            "field4": "",
                            "description": "CARREFOUR Ricarica ml 33",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 69.16186820217533,
                                "left": 34.743442098528476,
                                "width": 30.310034122414162,
                                "height": 25.27191298784389
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/4001335_1591705784.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_ghQyMQw_WD3E6Bb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213312",
                            "field1": "GREEN&GREEN",
                            "field2": "Terriccio universale",
                            "field3": "lt 20",
                            "field4": "",
                            "description": "GREEN&GREEN Terriccio universale lt 20",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 69.16186820217533,
                                "left": 65.43751332906804,
                                "width": 34.56248667093197,
                                "height": 25.27191298784389
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/green_terriccio_1591705416.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_Opu9dxI_uxed7Tr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Torba, che cos’è",
                                    "data": {
                                        "titolo": "Torba, che cos’è",
                                        "testo": "Spesso, al terriccio per piante consigliamo di aggiungere della torba. La torba è un materiale organico che si ottiene dalla decomposizione di muschi e piante paludose. Si tratta di un composto inerte quindi non va a fertilizzare il suolo ma ne va a regolare la reazione di pH e le caratteristiche strutturali.\nLa torba si ottiene dai giacimenti naturali detti torbiere. La torba viene aggiunta al terriccio per piante per modificarne reazione e struttura. La torba è utile al terreno perché, ha un pH di circa 3,5. E’ fibrosa, leggera e spugnosa ma quando bagnata in fretta non trattiene acqua.\n(Fonte: ideegreen.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/images/green_terriccio_1591705416.jpg"
                                        ]
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 8,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_8_NMsA5hx.jpg",
                    "products": [
                        {
                            "item_id": "213276",
                            "field1": "PLASTIME",
                            "field2": "Bottiglia termica spring con rubinetto ",
                            "field3": "lt 4/6",
                            "field4": "",
                            "description": "PLASTIME Bottiglia termica spring con rubinetto  lt 4/6",
                            "grammage": null,
                            "price": "13.99",
                            "price_label": "€ 13,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "4 lt",
                                "6 lt"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 7.357645553422905,
                                "left": 0.0,
                                "width": 57.82632224354874,
                                "height": 24.76007677543186
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008133007134_1590160629.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008133073016_1590160629.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_SzszlNa_l3alpJ2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213275",
                            "field1": "PLASTIME",
                            "field2": "Bottiglia termica meteo azzurro  ",
                            "field3": "cm 11x28 - lt 2,5",
                            "field4": "",
                            "description": "PLASTIME Bottiglia termica meteo azzurro   cm 11x28 - lt 2,5",
                            "grammage": null,
                            "price": "12.99",
                            "price_label": "€ 12,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 58.18823309874173,
                                "width": 41.81176690125827,
                                "height": 24.76007677543186
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8008133008087_1590160629.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_Lezbx0V_lKl8wAx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "212938",
                            "field1": "CARRERA",
                            "field2": "Borraccia alluminio",
                            "field3": "",
                            "field4": "ml 500/750",
                            "description": "CARRERA Borraccia alluminio ml 500/750",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "500 ml",
                                "750 ml"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 33.01343570057581,
                                "left": 0.0,
                                "width": 47.240429729153334,
                                "height": 35.316698656429935
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8021723048263_1590160628.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8021723048256_1590160628.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_DCjyzhD_yzKTxeV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Come lavare le borracce",
                                    "data": {
                                        "titolo": "Come lavare le borracce",
                                        "testo": "Se avete una borraccia in acciaio inossidabile, riempitela per metà con dell’acqua calda e una goccia di detersivo per i piatti. Dopo averla chiusa, agitate energicamente per alcuni secondi, poi svuotatela, risciacquate più volte e fatela asciugare. Non dimenticate di strofinare anche il tappo e la sua filettatura.\nSe è “lavabile in lavastoviglie”, vi basterà mettere la borraccia insieme al resto dei piatti in un normale carico.\nAceto o bicarbonato: altro metodo è riempire mezza borraccia con aceto bianco e acqua, lasciare agire la soluzione tutta la notte e poi sciacqua bene il mattino dopo. Stesso procedimento mettendo un cucchiaio di bicarbonato invece dell’aceto.\nSe la borraccia è in alluminio, meglio non pulire con sostanze acide e nemmeno con il bicarbonato, che non dovrebbe mai essere usato per pulire pentole o utensili da cucina in alluminio. Essendo infatti fortemente alcalino, il bicarbonato reagisce con l’alluminio causandone la perdita di lucentezza e colore.\nIn tutti casi, comunque, usate sempre uno scovolino per bottiglie, soprattutto se il collo della borraccia è troppo stretto per raggiungere il fondo e le pareti interne con la spugna.\n(Fonte: greenme.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/images/8021723048256_1590160628.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "213292",
                            "field1": "FRIGO BOX ELETTRICO IBIZA",
                            "field2": "Caldo freddo 12v ",
                            "field3": "lt 30",
                            "field4": "",
                            "description": "FRIGO BOX ELETTRICO IBIZA Caldo freddo 12v  lt 30",
                            "grammage": null,
                            "price": "34.99",
                            "price_label": "€ 34,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 33.01343570057581,
                                "left": 45.15944231179357,
                                "width": 54.84055768820644,
                                "height": 35.316698656429935
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8006772930646_1590160652.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_VEOaMnL_ZTrtSX9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "90959",
                            "field1": "FRIGO BOX PLAYA ",
                            "field2": "Termoretratto con coperchio  ",
                            "field3": "coibentato",
                            "field4": "lt 30 ",
                            "description": "FRIGO BOX PLAYA  Termoretratto con coperchio   coibentato lt 30 ",
                            "grammage": null,
                            "price": "14.99",
                            "price_label": "€ 14,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 69.28982725527833,
                                "left": 0.0,
                                "width": 49.77380571550437,
                                "height": 25.27191298784389
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1034374_1494586959.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8006772934026_1590160653.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_hQmG1oZ_GapkYZJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "I trucchi per usare bene il frigo box",
                                    "data": {
                                        "titolo": "I trucchi per usare bene il frigo box",
                                        "testo": "1. Pre-raffreddare il contenitore.\nÈ importante la temperatura di partenza, e se la tenete in veranda al sole o in soffitta il ghiaccio che poi ci mettete dovrà raffreddare innanzitutto il contenitore. Perciò tenetela in luogo fresco e riparato, e il giorno prima di usarla, pre-raffreddatela con ghiaccio.\n2. Inserire cibi congelati o freddi.\nPer lo stesso principio, nella borsa termica dureranno di più gli alimenti che provengono dal freezer o dal frigo, che devono mantenere una temperatura bassa, e non raggiungerla.\n3. Usare tanto ghiaccio.\nQuante volte abbiamo riempito la borsa di cibo e poi infilato qualche pezzo di ghiaccio qua e là? Il rapporto corretto, dicono gli esperti, è di 2 a 1.\n4. Evitare i vuoti.\nSe cibo+ghiaccio non riempie la borsa, cercate di evitare lo spazio vuoto in qualche modo: l'aria dentro il contenitore è comunque materia che assorbe il freddo e cede calore agli altri corpi.\n5. Non scolare l'acqua\nPrima o poi il ghiaccio inizia a sciogliersi, comunque. Ma è questo il momento in cui bisogna tenere duro e resistere alla tentazione: quella di svuotare la borsa dall'acqua. Infatti il ghiaccio appena sciolto è comunque a una temperatura bassa, e continua a svolgere la sua funzione raffreddante. Se volete evitare che i cibi subiscano danni, chiudeteli bene.\n(Fonte: esquire.com)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/images/frigo.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "213293",
                            "field1": "COVERI",
                            "field2": "Porta bottiglia in nylon con cerniera 4 colori ",
                            "field3": "lt 0,5",
                            "field4": "",
                            "description": "COVERI Porta bottiglia in nylon con cerniera 4 colori  lt 0,5",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 69.16186820217533,
                                "left": 50.22619428449563,
                                "width": 49.77380571550437,
                                "height": 25.27191298784389
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8032089270939_1590160653.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_j6nkI5K_t6p1IRD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 9,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_9_3jjCYKw.jpg",
                    "products": [
                        {
                            "item_id": "213289",
                            "field1": "COVERI BORDING",
                            "field2": "Borsa frigo in poliestere ",
                            "field3": "lt 7/8/30",
                            "field4": "",
                            "description": "COVERI BORDING Borsa frigo in poliestere  lt 7/8/30",
                            "grammage": null,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "7 lt",
                                "8 lt",
                                "30 lt"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 0.0,
                                "width": 49.77380571550437,
                                "height": 24.824056301983365
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8032089270236_1590160648.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8032089270281_1590160649.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8032089269933_1590160649.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_rywVdsO_87ypurW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213294",
                            "field1": "COVERI BORDING",
                            "field2": "Postina frigo in poliestere",
                            "field3": "4 colori",
                            "field4": "lt 17",
                            "description": "COVERI BORDING Postina frigo in poliestere 4 colori lt 17",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 50.22619428449563,
                                "width": 49.77380571550437,
                                "height": 24.824056301983365
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8032089270137_1590160654.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_oA0fzew_gPCzyac.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213295",
                            "field1": "ICE BAG TORTORA",
                            "field2": "Set 2 borse termiche ",
                            "field3": "lt 7 + lt 23",
                            "field4": "",
                            "description": "ICE BAG TORTORA Set 2 borse termiche  lt 7 + lt 23",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 33.07741522712732,
                                "left": 0.0,
                                "width": 57.82632224354874,
                                "height": 34.996801023672425
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8051836127692_1590160654.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_Bt2MNV3_ZdyMhwi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213291",
                            "field1": "TRAFFIC",
                            "field2": "Borsa termica con maniglia soft ",
                            "field3": "lt 7/16",
                            "field4": "",
                            "description": "TRAFFIC Borsa termica con maniglia soft  lt 7/16",
                            "grammage": null,
                            "price": "9.99",
                            "price_label": "€ 9,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "7 lt",
                                "16 lt"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 33.07741522712732,
                                "left": 53.48339198123267,
                                "width": 46.51660801876733,
                                "height": 34.996801023672425
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8006772907204_1590160651.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8006772907211_1590160652.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_moaFm3e_Fg1pYE9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213290",
                            "field1": "BETTIE",
                            "field2": "Borsa termica rettangolare ",
                            "field3": "lt 18",
                            "field4": "",
                            "description": "BETTIE Borsa termica rettangolare  lt 18",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 69.16186820217533,
                                "left": 0.0,
                                "width": 49.68332800170612,
                                "height": 25.399872040946892
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8051836127814_1590160651.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_9tn39Nc_Z4GaWMr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "212945",
                            "field1": "DUESSE",
                            "field2": "Borsa frigo classica con tracolla",
                            "field3": "piccola/grande",
                            "field4": "6 colori",
                            "description": "DUESSE Borsa frigo classica con tracolla piccola/grande 6 colori",
                            "grammage": null,
                            "price": "2.59",
                            "price_label": "€ 2,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Piccola",
                                "Grande"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 69.03390914907229,
                                "left": 50.316671998293884,
                                "width": 49.68332800170612,
                                "height": 25.399872040946892
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8034048163023_1590160650.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8034048163009_1590160650.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_C3LX8NP_kFPFzps.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 10,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_10_lFVYNIe.jpg",
                    "products": [
                        {
                            "item_id": "213299",
                            "field1": "COVERI",
                            "field2": "Sedia regista bianco texilene in alluminio  ",
                            "field3": "",
                            "field4": "",
                            "description": "COVERI Sedia regista bianco texilene in alluminio  ",
                            "grammage": null,
                            "price": "23.99",
                            "price_label": "€ 23,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 7.293666026871401,
                                "left": 0.0,
                                "width": 49.864283429302624,
                                "height": 24.632117722328857
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8056378854464_1590160658.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_FtERSw5_s3YbTdv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "126639",
                            "field1": "SEDIOLINA",
                            "field2": "in Metallo ",
                            "field3": "con ombrellone",
                            "field4": "4 colori",
                            "description": "SEDIOLINA in Metallo  con ombrellone 4 colori",
                            "grammage": null,
                            "price": "12.99",
                            "price_label": "€ 12,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 50.135716570697376,
                                "width": 49.864283429302624,
                                "height": 24.632117722328857
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1034352_1525432326_1591704780.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1034352_1525432326_arancio_1591704781.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1034352_1525432326_blu_1591704781.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_Ppi2muv_gMqmuSz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213301",
                            "field1": "SPIAGGINA ALLUMINIO",
                            "field2": "Con braccioli regolabili blue stripe ",
                            "field3": "",
                            "field4": "cm 76x46x79",
                            "description": "SPIAGGINA ALLUMINIO Con braccioli regolabili blue stripe  cm 76x46x79",
                            "grammage": null,
                            "price": "24.99",
                            "price_label": "€ 24,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 33.07741522712732,
                                "left": 0.0,
                                "width": 52.861111111111114,
                                "height": 35.316698656429935
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8032781039155_1590160660.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_R7abHW2_hzN5LNv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213302",
                            "field1": "OMBRELLONE MARE TNT",
                            "field2": "Colori assortiti  ",
                            "field3": "cm 180",
                            "field4": "",
                            "description": "OMBRELLONE MARE TNT Colori assortiti   cm 180",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 33.07741522712732,
                                "left": 52.861111111111114,
                                "width": 47.138888888888886,
                                "height": 35.316698656429935
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8050534201765_1590160660.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_waKQ2E2_GYTK2Qf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213300",
                            "field1": "SGABELLO PIEGHEVOLE",
                            "field2": "6 colori ",
                            "field3": "cm 43",
                            "field4": "",
                            "description": "SGABELLO PIEGHEVOLE 6 colori  cm 43",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 69.22584772872682,
                                "left": 0.0,
                                "width": 34.381531243335466,
                                "height": 25.27191298784389
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8034048425435_1590160659_1591704851.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_je3bAs0_OnhiLtD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "127591",
                            "field1": "OMBRELLONE MARE DUPLEFACE",
                            "field2": "Senza bordo",
                            "field3": "diametro cm 200",
                            "field4": "",
                            "description": "OMBRELLONE MARE DUPLEFACE Senza bordo diametro cm 200",
                            "grammage": null,
                            "price": "15.99",
                            "price_label": "€ 15,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 69.28982725527833,
                                "left": 34.92439752612497,
                                "width": 30.21955640861591,
                                "height": 25.27191298784389
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1038277_1526639224.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_xVnfya3_SFYLpk0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213303",
                            "field1": "OMBRELLONE MARE",
                            "field2": "Con snodo tinta unita in nylon ",
                            "field3": "",
                            "field4": "cm 200",
                            "description": "OMBRELLONE MARE Con snodo tinta unita in nylon  cm 200",
                            "grammage": null,
                            "price": "9.99",
                            "price_label": "€ 9,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 69.28982725527833,
                                "left": 65.59634250373215,
                                "width": 34.40365749626787,
                                "height": 25.27191298784389
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/OMBRELLONE_MARE_Con_snodo_tinta_unita__in_nylon__cm_200_1591704993.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_GOYkGWD_TDHd55U.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 11,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_11_7K5VPpE.jpg",
                    "products": [
                        {
                            "item_id": "212949",
                            "field1": "BESTWAY",
                            "field2": "Maschera splash tech dive lenti in policarbonato",
                            "field3": "14+ anni ",
                            "field4": "3 colori ",
                            "description": "BESTWAY Maschera splash tech dive lenti in policarbonato 14+ anni  3 colori ",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rosso",
                                "Blu",
                                "Grigio"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Nuoto",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 0.0,
                                "width": 49.68332800170612,
                                "height": 24.82405630198337
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138914757_1590160641.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_HaXgysR_Gsvhz3J.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213287",
                            "field1": "BESTWAY",
                            "field2": "Set da snorkeling aqua prime  ",
                            "field3": "anni 14+",
                            "field4": "2 colori",
                            "description": "BESTWAY Set da snorkeling aqua prime   anni 14+ 2 colori",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rosso",
                                "Grigio"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Nuoto",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 50.40714971209213,
                                "width": 49.59285028790787,
                                "height": 24.82405630198337
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138946567_1590160646.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_TfkkW2t_mrvh4Hv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Come fare snorkeling",
                                    "data": {
                                        "titolo": "Come fare snorkeling",
                                        "testo": "Vi proponiamo alcuni semplici passaggi alla portata di tutti:\n1 - Indossare una maschera adatta. Regola le cinghie affinché la maschera vi calzi perfettamente. Se potete, provate in acqua per essere sicura che non ci siano infiltrazioni.\n2 - Stendersi in acqua sulla pancia. Indossate il boccaglio circondandolo con le labbra. Successivamente, immergete prima la faccia e poi la testa in acqua.\n3 - Respirare lentamente e con regolarità attraverso il boccaglio. Se non siete abituati ad immergere la testa in acqua, non dovete farvi prendere dall’ansia. Potete uscire quando volete. Quando avete raggiunto un ritmo tranquillo di respirazione, rilassatevi e godetevi lo spettacolo.\n4 - Ricordarsi di svuotare il boccaglio. Le onde possono far entrare dell’acqua nel boccaglio. Per questo, ricordatevi sempre di far uscire i residui d’acqua soffiando forte nel tubo, anche più di una volta se necessario. Inoltre, ricordatevi di sciacquarlo regolarmente quando finisci di fare snorkeling.\n(Fonte: nonsprecare.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/images/come-fare-snorkeling-3-640x427.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "103525",
                            "field1": "SET FUNDIVE SNORKEL",
                            "field2": "Lenti in policarbonato",
                            "field3": "boccaglio in silicone 3-6 anni",
                            "field4": "2 colori",
                            "description": "SET FUNDIVE SNORKEL Lenti in policarbonato boccaglio in silicone 3-6 anni 2 colori",
                            "grammage": null,
                            "price": "5.49",
                            "price_label": "€ 5,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Blu",
                                "Verde"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Nuoto",
                            "blueprint": {
                                "top": 32.94945617402431,
                                "left": 0.0,
                                "width": 100.0,
                                "height": 35.18873960332694
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/maschera_blu_1498638120.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138914788_1590160647.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_HmpqVFE_HBFwL06.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213283",
                            "field1": "BESTWAY",
                            "field2": "Occhialini activwave",
                            "field3": "3 colori",
                            "field4": "",
                            "description": "BESTWAY Occhialini activwave 3 colori",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Azzurro",
                                "Nero",
                                "Grigio"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Nuoto",
                            "blueprint": {
                                "top": 69.28982725527833,
                                "left": 0.0,
                                "width": 49.875346555768814,
                                "height": 25.207933461292384
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138914627_1590160642.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_9iS31pr_BOH8imA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213284",
                            "field1": "BESTWAY",
                            "field2": "Occhialini sunrays 7-14 anni in silicone",
                            "field3": "3 colori",
                            "field4": "",
                            "description": "BESTWAY Occhialini sunrays 7-14 anni in silicone 3 colori",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Giallo",
                                "Blu",
                                "Arancione"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Nuoto",
                            "blueprint": {
                                "top": 69.28982725527833,
                                "left": 50.327735124760075,
                                "width": 49.672264875239925,
                                "height": 25.207933461292384
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138914597_1590160642.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_fqcULiY_i6ugeig.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 12,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_12_mZk0r2x.jpg",
                    "products": [
                        {
                            "item_id": "92447",
                            "field1": "BESTWAY AIRBED",
                            "field2": "Materasso gonfiabile matrimoniale ",
                            "field3": "cm 191x137x22",
                            "field4": "",
                            "description": "BESTWAY AIRBED Materasso gonfiabile matrimoniale  cm 191x137x22",
                            "grammage": null,
                            "price": "18.99",
                            "price_label": "€ 18,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 7.293666026871401,
                                "left": 0.0,
                                "width": 49.68332800170612,
                                "height": 24.888035828534868
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1055999_1495209795.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138916225_1590160662.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_9Ol7R1b_obmwDFp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213306",
                            "field1": "BESTWAY",
                            "field2": "Materassino fashion rainbow ",
                            "field3": "2 colori",
                            "field4": "cm 183x69",
                            "description": "BESTWAY Materassino fashion rainbow  2 colori cm 183x69",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Con Giallo",
                                "Con Verde"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 7.293666026871401,
                                "left": 50.316671998293884,
                                "width": 49.68332800170612,
                                "height": 24.888035828534868
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138970975_1590160668.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_ynIudmY_jjoI6e7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "128626",
                            "field1": "MATERASSINO",
                            "field2": "Tinta unita eco",
                            "field3": "4 colori",
                            "field4": "cm 183x69",
                            "description": "MATERASSINO Tinta unita eco 4 colori cm 183x69",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Giallo",
                                "Azzurro",
                                "Verde",
                                "Fuxia"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 32.94945617402431,
                                "left": 0.0,
                                "width": 99.99999999999997,
                                "height": 35.380678182981434
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/702525_-_MATERASSINO_T.UNITA_ECO_183x69_1_1433758217_1528108639.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/702525_-_MATERASSINO_T.UNITA_ECO_183x69_2_1433758206_1528108641.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/702525_-_MATERASSINO_T.UNITA_ECO_183x69_3_1433758142_1528108643.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/702525_-_MATERASSINO_T.UNITA_ECO_183x69_1433758106_1528108645.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138940480_1590160667.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_lJrasGT_JJqz3Az.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213307",
                            "field1": "BESTWAY",
                            "field2": "Materassino fashion frasi ",
                            "field3": "cm 183x69",
                            "field4": "",
                            "description": "BESTWAY Materassino fashion frasi  cm 183x69",
                            "grammage": null,
                            "price": "6.49",
                            "price_label": "€ 6,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 69.16186820217533,
                                "left": 0.0,
                                "width": 49.69439112817232,
                                "height": 25.399872040946892
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138967883_1590160668.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_gB0uE9I_qPRuERI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213305",
                            "field1": "GOLD",
                            "field2": "Cuscino gonfiabile ",
                            "field3": "cm 43x28",
                            "field4": "",
                            "description": "GOLD Cuscino gonfiabile  cm 43x28",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 69.16186820217533,
                                "left": 50.327735124760075,
                                "width": 49.672264875239925,
                                "height": 25.399872040946892
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8031948211373_1590160667.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_N1Y0AT1_07F63CC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 13,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_13_cIqzgMU.jpg",
                    "products": [
                        {
                            "item_id": "92372",
                            "field1": "CANOTTO",
                            "field2": "Spiderman/Lol",
                            "field3": "cm 112",
                            "field4": "",
                            "description": "CANOTTO Spiderman/Lol cm 112",
                            "grammage": null,
                            "price": "11.99",
                            "price_label": "€ 11,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Lol",
                                "Spiderman"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 7.165706973768394,
                                "left": 0.0,
                                "width": 100.0,
                                "height": 24.888035828534868
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1055525_1495208930.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011168040_1590160665.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138911763_1590160665.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/Logo_Lol_1591705200.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/logo_spiderman_1591705201.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_9jgtnUP_YQBO2P4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92441",
                            "field1": "BESTWAY",
                            "field2": "Salvagente",
                            "field3": "principesse/spiderman",
                            "field4": "cm 56",
                            "description": "BESTWAY Salvagente principesse/spiderman cm 56",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Principessa",
                                "Spiderman"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 33.01343570057581,
                                "left": 0.0,
                                "width": 56.29926423544465,
                                "height": 35.252719129878436
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1036438_1527264140.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138919585_1590160670.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138908664_1590160671.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_bgTbrtA_bvjw4Uf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213308",
                            "field1": "BEST WAY",
                            "field2": "Salvagente fashion unicorno fantasy",
                            "field3": "cm 119x91",
                            "field4": "",
                            "description": "BEST WAY Salvagente fashion unicorno fantasy cm 119x91",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 33.01343570057581,
                                "left": 56.299264235444646,
                                "width": 43.70073576455535,
                                "height": 35.252719129878436
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138967432_1590160669.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_Ps5psGW_EOEGmjp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "212940",
                            "field1": "MONDO",
                            "field2": "Braccioli",
                            "field3": "vari personaggi",
                            "field4": "",
                            "description": "MONDO Braccioli vari personaggi",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bing",
                                "Spider Man",
                                "Lol"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 68.9699296225208,
                                "left": 0.0,
                                "width": 49.85322030283642,
                                "height": 25.591810620601407
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138919561_1590160663.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011168019_1590160663.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011168415_1590160664.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_4iV6SOF_7xVqSqV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "180206",
                            "field1": "BESTWAY",
                            "field2": "Piscina a 4 anelli colorati",
                            "field3": "cm 157x46",
                            "field4": "",
                            "description": "BESTWAY Piscina a 4 anelli colorati cm 157x46",
                            "grammage": null,
                            "price": "14.99",
                            "price_label": "€ 14,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 68.9699296225208,
                                "left": 50.39608658562592,
                                "width": 49.60391341437408,
                                "height": 25.591810620601407
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/1034517_1558446262.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/6942138913422_1590160669.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_jhzXSq6_ltlbqJQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 14,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_14_IXGXqJi.jpg",
                    "products": [
                        {
                            "item_id": "213309",
                            "field1": "MITRAGLIETTA ACQUA",
                            "field2": "Avengers/spiderman ",
                            "field3": "cm 29",
                            "field4": "",
                            "description": "MITRAGLIETTA ACQUA Avengers/spiderman  cm 29",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Avengers",
                                "Spiderman"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 0.0,
                                "width": 49.95476114310088,
                                "height": 24.82405630198337
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8026196950013_1590160673.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8026196950020_1590160673.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_lXLkrpZ_D7pIsVo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213282",
                            "field1": "MINI BARCA",
                            "field2": "In display assortita",
                            "field3": "",
                            "field4": "",
                            "description": "MINI BARCA In display assortita",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 7.229686500319897,
                                "left": 50.22619428449563,
                                "width": 49.77380571550437,
                                "height": 24.82405630198337
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8002936874009_1590160640.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_mlHIWoy_sO8817u.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "92451",
                            "field1": "SECCHIELLO CON INNAFFIATOIO",
                            "field2": "Vari personaggi",
                            "field3": "diametro cm 18",
                            "field4": "",
                            "description": "SECCHIELLO CON INNAFFIATOIO Vari personaggi diametro cm 18",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Princess",
                                "Topolino",
                                "Spider Man",
                                "Frozen"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 32.94945617402431,
                                "left": 0.0,
                                "width": 60.63113137129453,
                                "height": 35.444657709532954
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011284153_1590160675.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8002936690005_1590160675.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8002936759009_1590160675.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8002936754004_1590160675.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_k24txYc_E14AGYI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "212947",
                            "field1": "MONDO ",
                            "field2": "Camion plastica",
                            "field3": "assortito",
                            "field4": "",
                            "description": "MONDO  Camion plastica assortito",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 32.94945617402431,
                                "left": 54.84055768820644,
                                "width": 45.15944231179357,
                                "height": 35.444657709532954
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011282357_1590160641.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_hsnsnRC_BhYFDLH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213286",
                            "field1": "SACCA",
                            "field2": "Rete mare 3 colori ",
                            "field3": "cm 80",
                            "field4": "",
                            "description": "SACCA Rete mare 3 colori  cm 80",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rossa",
                                "Blu",
                                "Arancione"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Abbigliamento",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 69.22584772872682,
                                "left": 50.04523885689912,
                                "width": 49.95476114310088,
                                "height": 25.335892514395393
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8034048219188_1590160646.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_ehBqZfH_wsd5Qbs.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84234735",
                            "field1": "GABBIANO SUMMER",
                            "field2": "occhiali da sole",
                            "field3": "KIDS",
                            "field4": "",
                            "description": "GABBIANO SUMMER occhiali da sole KIDS",
                            "grammage": null,
                            "price": "12.89",
                            "price_label": "€ 12,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Abbigliamento",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 77.75648969832993,
                                "left": 27.63611406305349,
                                "width": 21.88469713071201,
                                "height": 6.1235774577503435
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/Spiderman_QkoymWJ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/Jason_hNWHzbM.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/frozen_4oXlkCA.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_RYXhJKR_HRSPFhr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm08012073",
                            "field1": "GABBIANO SUMMER",
                            "field2": "occhiali da sole",
                            "field3": "JUNIOR",
                            "field4": "",
                            "description": "GABBIANO SUMMER occhiali da sole JUNIOR",
                            "grammage": null,
                            "price": "9.89",
                            "price_label": "€ 9,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Abbigliamento",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 83.52408935905936,
                                "left": 27.87600662737353,
                                "width": 21.88469713071201,
                                "height": 5.190583394985289
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/Jason_bL6M93S_2poh9Pg.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/Spiderman_7lzycNe_Nxmle3E.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/frozen_DMLepy9_GHkJrbk.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_KhJV1Ws_Niu9sgW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm96691248",
                            "field1": "GABBIANO SUMMER",
                            "field2": "occhiali da sole",
                            "field3": "ADULTO",
                            "field4": "",
                            "description": "GABBIANO SUMMER occhiali da sole ADULTO",
                            "grammage": null,
                            "price": "6.99",
                            "price_label": "€ 6,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Abbigliamento",
                            "subcategory": "Accessori",
                            "blueprint": {
                                "top": 88.35869495702373,
                                "left": 27.87600662737353,
                                "width": 21.88469713071201,
                                "height": 5.190583394985289
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/Jason_czu4vjw_sJZm2ld.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/Spiderman_HhAmgDy_Kiqs3MX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/frozen_3fLjeOj_EM7VQPM.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_lgXgw8u_Nn5P8MN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 15,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_15_zrNIMFU.jpg",
                    "products": [
                        {
                            "item_id": "212281",
                            "field1": "MONDO ",
                            "field2": "Pallone",
                            "field3": "vari tipi",
                            "field4": "diametro cm 230",
                            "description": "MONDO  Pallone vari tipi diametro cm 230",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 7.165706973768394,
                                "left": 0.0,
                                "width": 49.762742589038176,
                                "height": 25.14395393474088
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011023400_1590160644.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011069606_1590160644.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011061112_1590160644.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011168033_1590160644.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_yx7zoPG_ZDlgKTP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "212942",
                            "field1": "MONDO",
                            "field2": "Set racchette",
                            "field3": "2 pz assortiti",
                            "field4": "+ palina",
                            "description": "MONDO Set racchette 2 pz assortiti + palina",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 7.165706973768394,
                                "left": 50.30560887182768,
                                "width": 49.69439112817232,
                                "height": 25.143953934740882
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011194261_1590160645.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_lLZWv3f_sa8t33G.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "103543",
                            "field1": "MONDO",
                            "field2": "Tavola surf ",
                            "field3": "vari personaggi",
                            "field4": "cm 94 ",
                            "description": "MONDO Tavola surf  vari personaggi cm 94 ",
                            "grammage": null,
                            "price": "12.99",
                            "price_label": "€ 12,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Paw Patrol",
                                " Spider Man",
                                " Pigiamask",
                                " Lol",
                                " Frozen",
                                " Avengers"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 32.94945617402431,
                                "left": 0.0,
                                "width": 100.0,
                                "height": 35.316698656429935
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/tavoletta_pawpatrol_1498637929.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/tavoletta_spiderman_1498637930.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011111824_1590160672.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011111985_1590160672.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011111473_1590160672.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8001011111046_1590160673.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_vaxUzMz_6KEsA2H.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213310",
                            "field1": "BOLLE DI SAPONE",
                            "field2": "Vari personaggi",
                            "field3": "4 colori",
                            "field4": "cl 60",
                            "description": "BOLLE DI SAPONE Vari personaggi 4 colori cl 60",
                            "grammage": null,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bing",
                                "Barbie",
                                "Topolino",
                                "Princess",
                                "Spider Man"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giochi e Giocattoli",
                            "subcategory": "Giochi all'Aperto",
                            "blueprint": {
                                "top": 69.41778630838132,
                                "left": 0.0,
                                "width": 49.78486884197057,
                                "height": 25.14395393474088
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8007315513005_1590160676.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8007315448000_1590160676.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8007315410021_1590160676.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8007315819008_1590160677.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8007315550000_1590160677.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_6HP1UnY_5c0yShT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "213285",
                            "field1": "RETINO MEDIO DA PESCA",
                            "field2": "Rotondo con manico in ferro ",
                            "field3": "diametro cm 24",
                            "field4": "",
                            "description": "RETINO MEDIO DA PESCA Rotondo con manico in ferro  diametro cm 24",
                            "grammage": null,
                            "price": "3.29",
                            "price_label": "€ 3,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 69.41778630838132,
                                "left": 50.23725741096183,
                                "width": 49.762742589038176,
                                "height": 25.143953934740882
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/8002936100108_1590160645.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_u6ovMqM_Bi8Ju7P.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 16,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/page_16_gD3EfYf.jpg",
                    "products": [
                        {
                            "item_id": "214440",
                            "field1": "SET NEBRASKA",
                            "field2": "per 4 persone  ",
                            "field3": "con finiture in rattan  bianco/marrone ",
                            "field4": "COMPOSTO DA:  - 2 POLTRONE CON SCHIENALE     ALTO ED ERGONOMICO - 1 SOFA DA DUE POSTI - 4 CUSCINI - 1 TAVOLINO ",
                            "description": "SET NEBRASKA per 4 persone   con finiture in rattan  bianco/marrone  COMPOSTO DA:  - 2 POLTRONE CON SCHIENALE     ALTO ED ERGONOMICO - 1 SOFA DA DUE POSTI - 4 CUSCINI - 1 TAVOLINO ",
                            "grammage": null,
                            "price": "179.99",
                            "price_label": "€ 179,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Marrone"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Arredamento",
                            "blueprint": {
                                "top": 7.9974408189379425,
                                "left": -1.524219768574118e-15,
                                "width": 100.0,
                                "height": 43.44209852847089
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/SET_NEBRASKA_BIANCO_1591706389.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/SET_NEBRASKA_marrone_1591706390.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/products/cropped_image_WeqI0zz_SLB8J9S.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "Pulizia",
                                    "data": {
                                        "titolo": "Pulizia",
                                        "testo": "Se si trovano all'esterno, probabilmente sono più soggetti all'usura rispetto ai mobili che si trovano all'interno, soprattutto a causa dell'esposizione diretta alla luce solare. Questo si nota facilmente perché il colore del materiale si schiarisce o si scurisce a seconda dei casi. Per questo è necessario pulirli regolarmente per mantenere il loro aspetto originario.\nLa pulizia dei mobili in rattan va effettuata con alcune gocce di detersivo diluito in acqua e passando un panno sulla superficie. Per raggiungere tutti gli angoli è possibile utilizzare un vecchio spazzolino da denti. Una volta terminata la pulizia, occorre lasciar asciugare il mobile.\nSe si ha intenzione di dipingere o laccare il rattan, al momento di pulirlo occorre sostituire il detersivo con ammoniaca.\n(Fonte: progetti.habitatissimo.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/images/SET_NEBRASKA_BIANCO_1591706389.jpg"
                                        ]
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 17,
                    "image_file": "https://interattivo.s3.amazonaws.com/SFeRwJ6uok/pages/Carrefour-fine-pagina_X4ZnNBK.png",
                    "products": []
                }
            ]
        }

    }

}

const lefletSwitch = () => {
    return leaflets.apulia;
}

export const serverResponse = lefletSwitch();